var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlipay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_616_1105",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H21V21.0015H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_616_1105)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73161 11.8247C4.47283 12.0225 4.21418 12.3117 4.13807 12.6921C4.03152 13.1944 4.12284 13.8335 4.59461 14.3357C5.18817 14.9293 6.08605 15.0967 6.48172 15.1271C7.53183 15.2032 8.65802 14.6706 9.51026 14.0922C9.84502 13.8639 10.4081 13.3922 10.956 12.6617C9.73848 12.0377 8.21661 11.3377 6.6035 11.3986C5.75128 11.429 5.15772 11.5964 4.73161 11.8247ZM20.1631 14.6098C20.6957 13.3467 21.0001 11.9617 21.0001 10.5008C21.0001 4.71774 16.2823 0 10.4994 0C4.71627 0 -0.00146484 4.71774 -0.00146484 10.5008C-0.00146484 16.2838 4.71627 21.0015 10.4994 21.0015C13.9996 21.0015 17.089 19.2819 19.0064 16.649C17.1954 15.7664 14.2279 14.275 12.3865 13.3923C11.5189 14.3967 10.2254 15.3859 8.76438 15.812C7.85128 16.086 7.01427 16.1925 6.16205 16.0099C5.29461 15.8272 4.67061 15.4316 4.30539 15.0359C4.12273 14.8228 3.90972 14.5793 3.74228 14.2598C3.75751 14.275 3.75751 14.3054 3.75751 14.3206C3.75751 14.3206 3.66617 14.1685 3.60531 13.9249C3.57485 13.8032 3.54439 13.6815 3.52919 13.5597C3.51407 13.4684 3.51407 13.377 3.52919 13.301C3.51407 13.1488 3.52919 12.9814 3.55962 12.814C3.65097 12.3879 3.8184 11.9162 4.29017 11.4748C5.29461 10.4856 6.64905 10.4399 7.34906 10.4399C8.38393 10.4551 10.1797 10.8965 11.7016 11.4444C12.1277 10.5465 12.4017 9.60293 12.569 8.94851H6.25337V8.26362H9.49492V6.89396H5.58372V6.19395H9.49492V4.82431C9.49492 4.64165 9.54058 4.48942 9.82969 4.48942H11.3668V6.19395H15.6128V6.87873H11.3668V8.2484H14.7605C14.7605 8.2484 14.4104 10.1507 13.3603 12.0226C15.7192 12.8597 19.0521 14.1685 20.1631 14.6098Z",
    fill: "#06B4FD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlipay);
export default __webpack_public_path__ + "static/media/alipay.0be6c94c1e0c7ce2f91ec21bc812a462.svg";
export { ForwardRef as ReactComponent };